<template>
  <div class="fields" v-if="fields.length || fieldsTxt.length">
    <div class="field" v-for="field in fields" :key="field.id" >
      <span>{{field.boardField.description}}</span>
      <span>{{field.value}}</span>
      <span v-if="field.boardField.suffix">{{field.boardField.suffix}}</span>
    </div>
    <div class="field" v-for="field in fieldsTxt" :key="field.id" >
      <span>{{field.boardField.description}}</span>
      <a v-if="field.boardField.type == 1" :href="field.value" target="_blank" rel="noopener noreferrer" @click.stop="" class="value link">
        {{field.value}}
      </a>
      <span class="value" v-else>{{field.value}}</span>
      <span v-if="field.boardField.suffix">{{field.boardField.suffix}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardFields",
  props: { card: { required: true } },
  computed: {
    fields() {
      if (!this.card)
        return [];

      const result = this.card.fields.filter(bf => bf.boardField.show_on_card);    
      return result;
    },
    fieldsTxt() {
      if (!this.card)
        return [];

      const result = this.card.fieldsTxt.filter(bf => bf.boardField.show_on_card);    
      return result;
    }
  }
}
</script>

<style lang="postcss" scoped>

.fields {
	font-size: 10px;
	color: #888;
	padding: 0px;
	border-top: 1px dashed #ddd;
	text-overflow: ellipsis;
	user-select: none;
	font-weight: bold;
}

.field {
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  grid-template-columns: auto auto 1fr;
  gap: 0.2em;
  
  .value{
    display:inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .link{
    color: var(--color-card-id);
  }
}
</style>
